var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiagramZoomIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 28H29.42L28.86 27.46C31.26 24.66 32.5 20.84 31.82 16.78C30.88 11.22 26.24 6.78003 20.64 6.10003C12.18 5.06003 5.08001 12.18 6.10001 20.64C6.78001 26.24 11.22 30.88 16.78 31.82C20.84 32.5 24.66 31.26 27.46 28.86L28 29.42V31L36.52 39.5C37.34 40.32 38.66 40.32 39.48 39.5L39.5 39.48C40.32 38.66 40.32 37.34 39.5 36.52L31 28ZM19 28C14.02 28 10 23.98 10 19C10 14.02 14.02 10 19 10C23.98 10 28 14.02 28 19C28 23.98 23.98 28 19 28ZM19 14C18.44 14 18 14.44 18 15V18H15C14.44 18 14 18.44 14 19C14 19.56 14.44 20 15 20H18V23C18 23.56 18.44 24 19 24C19.56 24 20 23.56 20 23V20H23C23.56 20 24 19.56 24 19C24 18.44 23.56 18 23 18H20V15C20 14.44 19.56 14 19 14Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagramZoomIn);
export default __webpack_public_path__ + "static/media/diagram_zoom_in.c9b55289f15569542d589ef0ebba1514.svg";
export { ForwardRef as ReactComponent };